@if (!isHiddenBar) {
<div class="arbol-tree">
  <div class="tree-block border-bottom-tree">
    <div class="tree-search">
      <i class="fal fa-search"></i>
      <input id="filter" #filter (keyup)="filterTree(filter.value)" placeholder="{{ 'buscar' | translate }}" class="tree-search-input" />
    </div>
    <nz-tree [nzData]="treeNodes" [nzShowLine]="true" [nzExpandedKeys]="expandedKeys" (nzClick)="onTreeClick($event)" (nzExpandChange)="onTreeExpand($event)">
      <ng-template #nzTreeTemplate let-node>
        <span class="node-content">{{ node.title | lowercase }}</span>
      </ng-template>
    </nz-tree>
  </div>
</div>
} @if (isHiddenBar) {
<div class="tree-toggle" style="height: 100%">
  <div class="tree-toggle-action" style="height: 100%">
    <button nz-button nzType="default" nzSize="small" style="height: 100%; min-height: 400px" (click)="clickHiddenButton()">
      <i class="fas fa-angle-double-right" style="color: grey"></i>
    </button>
  </div>
</div>
}

<div class="arbol-refresh">
  <button style="text-align: left; font-size: 16px" nz-button nzType="text" class="arbol-refresh-button" (click)="refrescarArbol()" [disabled]="loading">
    @if (!loading) {
    <span class="arbol-refresh-label"><i class="fa fa-sync fa-lg" style="font-size: 14px; margin-right: 2px"></i> {{ 'Actualizar' | lowercase | translate }}</span>
    } @if (loading) {
    <span class="arbol-refresh-loading"
      ><i class="fas fa-circle-notch fa-spin fa-lg" style="font-size: 14px; color: white; margin-right: 2px"></i> {{ 'Cargando' | translate }}</span
    >
    }
  </button>
</div>
